import { ListChecks } from "lucide-react";
import { formatPaymentLogDateTime } from "../../utils/applicationFormatters";
import styles from "../../styles/applicationDetail.module.css";
import type { NoteStatusRow } from "../../types/tabs";
import type { NotesTabStatusLogSectionProps } from "../../types";

export function NotesTabStatusLogSection({ tab }: NotesTabStatusLogSectionProps) {
  const { statusHistory } = tab;

  return (
    <div className={styles.section} data-testid="application-notes-tab-section-status-log">
      <h2 className={styles.sectionTitle} data-testid="application-notes-tab-status-log-title">
        <span className={styles.sectionTitleIcon} aria-hidden="true">
          <ListChecks className="h-4 w-4" />
        </span>
        Status Log
      </h2>
      <div className={styles.tableResponsive}>
        <table
          className={`${styles.table} ${styles.statusLogTable}`}
          data-testid="application-notes-tab-status-log-table"
          style={{ margin: 0 }}
        >
          <thead>
            <tr>
              <th style={{ width: "25%" }}>Status - Progress</th>
              <th>Description</th>
              <th style={{ width: "15%" }}>User Name</th>
              <th style={{ width: "18%" }}>Date / Time</th>
            </tr>
          </thead>
          <tbody>
            {statusHistory.map((status: NoteStatusRow, index: number) => (
              <tr key={index}>
                <td>{status.status}</td>
                <td>{status.description}</td>
                <td>{status.name || status.user_name}</td>
                <td>{formatPaymentLogDateTime(status.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
